import { pagesPath } from "faqSrc/lib/$path";
import Link from "next/link";
import React, { VFC } from "react";
import Image from "~/components/atoms/Image";
import IconTag from "~/components/icons/IconTag";
import { convertToLinkHref, externalLinkAttrs } from "~/lib/utils/urlHelper";
import { DictionaryItem } from "~/models/dictionaryItem";
import { Topic } from "~/models/topic";
import { Container, Text } from "./TopicItem";

interface Props {
  dictionaryItem: DictionaryItem;
  host?: string;
  isTextUnderline?: boolean;
  locale?: string;
  marginBottom?: number;
  marginRight?: number;
  topic: Topic;
}

const TagSubTopicItem: VFC<Props> = ({
  dictionaryItem,
  host,
  isTextUnderline = true,
  locale,
  marginBottom,
  marginRight,
  topic,
}) => {
  if (!topic || !dictionaryItem?.name) {
    return <></>;
  }

  const subTopicUrl = convertToLinkHref({
    host,
    locale,
    url: pagesPath.qa
      ._topicSlug(topic.slug)
      .s._subTopicSlug(dictionaryItem.slug)
      .$url(),
  });

  return (
    <Link href={subTopicUrl} passHref>
      <Container
        dataMarginBottom={marginBottom}
        dataMarginRight={marginRight}
        isTextUnderline={isTextUnderline}
        {...externalLinkAttrs(subTopicUrl)}
      >
        {dictionaryItem.images?.[0]?.url ? (
          <Image
            src={dictionaryItem.images[0].url}
            alt={dictionaryItem.name}
            width={18}
            height={18}
          />
        ) : (
          <IconTag />
        )}
        <Text>{dictionaryItem.name}</Text>
      </Container>
    </Link>
  );
};

export default TagSubTopicItem;
